import React from "react";

export default function ScoreRing(props) {
  var score = props.score;
  var circ = 2 * Math.PI * 65;
  var offset = circ - (score / 100) * circ;
  var stroke = score >= 75 ? "url(#rg)" : score >= 50 ? "#c9963a" : "#b85c38";
  var numColor = score >= 75 ? "#a07828" : score >= 50 ? "#c9963a" : "#b85c38";
  return (
    <div style={{ position: "relative", width: 144, height: 144, flexShrink: 0 }}>
      <svg viewBox="0 0 160 160" style={{ width: "100%", height: "100%", transform: "rotate(-90deg)" }}>
        <defs>
          <linearGradient id="rg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#a07828" /><stop offset="100%" stopColor="#e8c06a" />
          </linearGradient>
        </defs>
        <circle fill="none" stroke="#e4d9c8" strokeWidth={8} cx={80} cy={80} r={65} />
        <circle fill="none" stroke={stroke} strokeWidth={8} strokeLinecap="round"
          strokeDasharray={circ} strokeDashoffset={offset} cx={80} cy={80} r={65}
          style={{ transition: "stroke-dashoffset 1.8s cubic-bezier(.34,1.56,.64,1)" }} />
      </svg>
      <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <div style={{ fontFamily: "Georgia,serif", fontSize: 46, fontWeight: 500, lineHeight: 1, color: numColor }}>{score}</div>
        <div style={{ fontSize: 8, letterSpacing: 3, color: "#7a6e64", marginTop: 2 }}>ATS SCORE</div>
      </div>
    </div>
  );
}
